import { Component } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  AbstractControl
} from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ChangePasswordService } from './service/change-password.service';

@Component({
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent {
  changePasswordForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private service: ChangePasswordService,
    private activatedRoute: ActivatedRoute
  ) {
    this.changePasswordForm = this.formBuilder.group(
      {
        newPassword: ['', Validators.required],
        repeatPassword: ['', Validators.required]
      },
      { validator: this.areEqual }
    );
  }

  areEqual = (control: AbstractControl): { [key: string]: boolean } | null => {
    const newPassword = control.get('newPassword');
    const newPasswordRetype = control.get('repeatPassword');
    if (!newPassword || !newPasswordRetype) {
      return null;
    }
    return newPassword.value === newPasswordRetype.value
      ? null
      : { nomatch: true };
  };

  onFormSubmit(value: { newPassword: string; repeatPassword: string }): void {
    const token = this.activatedRoute.snapshot.queryParamMap.get('token') || '';
    this.service.changePassword({
      newPassword: value.newPassword,
      repeatPassword: value.repeatPassword,
      token: token
    });
  }

  changePasswordFormControl(controlName: string): FormControl {
    return this.changePasswordForm.controls[controlName] as FormControl;
  }
}
